/* eslint-disable react/no-unused-prop-types */
const PropTypes = require('prop-types');

const Hotjar = () => null;

/** @type {React.WeakValidationMap<import('../index.d.ts').HotjarProps>} */
Hotjar.propTypes = {
  id: PropTypes.number,
  tags: PropTypes.arrayOf(PropTypes.string.isRequired),
  tagPrefix: PropTypes.string,
  triggers: PropTypes.arrayOf(PropTypes.string.isRequired),
  disabled: PropTypes.bool,
};

Hotjar.Hotjar = Hotjar;

module.exports = Hotjar;
